import { brand } from "../config/brands";

const login = (email, password) => {
    const data = new FormData();
    data.append("phoneNumber", email);
    data.append("password", password);
   return fetch(`${brand.identityApiUrl}/login?phoneNumber=`+email+"&password="+password, {
    method: 'POST',
   body: {},
  }).then(res => res.json())
   .then((response) => {
      if (response.access_token) {
       localStorage.setItem("user", JSON.stringify(response.access_token));
      }
   return response;
   });
};

const logout = () => {
  localStorage.clear()
};



export default {
  login,
  logout
};
